export const useDeviceCheck = () => {
  const isLargeScreen = useState<boolean | null>('isLargeScreen', () => null);

  const setLargeScreenState = (isLarge: boolean): void => {
    isLargeScreen.value = isLarge;
  };

  return {
    isLargeScreen: readonly(isLargeScreen),
    setLargeScreenState,
  };
};
